import { BottomNav } from "@/components/BottomNav";
import { useEffect } from "react";
import { useMode } from "@/context/ModeContext";

export function CustomerShell({ children, noNav = false }) {
    const { mode, setMode } = useMode();
    useEffect(() => { if (mode !== "services") setMode("services"); }, []); // eslint-disable-line
    return (
        <div className="mx-auto min-h-screen max-w-md bg-lightbg">
            <div className={noNav ? "" : "pb-24"}>{children}</div>
            {!noNav && <BottomNav />}
        </div>
    );
}
